import { cn } from '@/shadcn/lib/utils';

type Props = {
  tabs: string[];
  value: string;
  loading?: boolean;
  onChange: (tab: string) => void;
};

export const RadioButtonsGroup = ({
  tabs,
  value,
  loading = false,
  onChange
}: Props) => (
  <div className="relative mr-2 flex shrink-0 items-center overflow-hidden rounded-md border border-border">
    {tabs.map(tab => {
      const tabSelected = value.toLowerCase() === tab.toLowerCase();
      const tabName = tab === 'Custom' ? 'Default' : tab;
      return (
        <button
          aria-label={`Click to select ${tabName} subscription mode`}
          className={cn(
            'cursor-pointer border-border border-r px-4 py-1 text-card-foreground text-sm last:border-r-0',
            tabSelected && 'cursor-default bg-primary text-primary-foreground'
          )}
          disabled={loading || tabSelected}
          key={tab}
          onClick={() => onChange(tab)}
          type="button"
        >
          {tabName}
        </button>
      );
    })}
  </div>
);
